import ConstantApi from '../../ConstantApi';
import axiosCall from '../axiosCall';
import {
    CREATE_SIZE_INFO_FAILURE,
    CREATE_SIZE_INFO_FORM,
    CREATE_SIZE_INFO_REQUEST,
    CREATE_SIZE_INFO_SUCCESS,
    DELETE_SIZE_INFO_FAILURE,
    DELETE_SIZE_INFO_REQUEST,
    DELETE_SIZE_INFO_SUCCESS,
    FETCH_GENDER_FAILURE,
    FETCH_GENDER_REQUEST,
    FETCH_GENDER_SUCCESS,
    FETCH_SINGLE_SIZE_INFO_FAILURE,
    FETCH_SINGLE_SIZE_INFO_REQUEST,
    FETCH_SINGLE_SIZE_INFO_SUCCESS,
    FETCH_SIZE_INFO_FAILURE,
    FETCH_SIZE_INFO_REQUEST,
    FETCH_SIZE_INFO_SUCCESS,
    RESET_SIZE_INFO_INFO,
    UPDATE_SIZE_INFO_FAILURE,
    UPDATE_SIZE_INFO_REQUEST,
    UPDATE_SIZE_INFO_SUCCESS,
    FETCH_SIZE_INFO_INVOICE_REQUEST,
    FETCH_SIZE_INFO_INVOICE_SUCCESS,
    FETCH_SIZE_INFO_INVOICE_FAILURE,
    UPDATE_SIZE_INFO_MES_REQUEST,
    UPDATE_SIZE_INFO_MES_SUCCESS,
    UPDATE_SIZE_INFO_MES_FAILURE,
    FETCH_SIZE_INFO_MES_REQUEST,
    FETCH_SIZE_INFO_MES_SUCCESS,
    FETCH_SIZE_INFO_MES_FAILURE,
    FETCH_SIZE_INFO_MES_SINGLE_GET_REQUEST,
    FETCH_SIZE_INFO_MES_SINGLE_GET_SUCCESS,
    FETCH_SIZE_INFO_MES_SINGLE_GET_FAILURE,
    CREATE_SIZE_INFO_MES_REQUEST,
    CREATE_SIZE_INFO_MES_SUCCESS,
    CREATE_SIZE_INFO_MES_FAILURE
} from './sizeInfo.actionsType';

// FETCH SIZE INFO DATA
export let fetchSizeInfoData = () => {
    let config = {
        method: 'get',
        url: ConstantApi.sizeInfoGET,
        responseTypeRequest: FETCH_SIZE_INFO_REQUEST,
        responseTypeSuccess: FETCH_SIZE_INFO_SUCCESS,
        responseTypeFailure: FETCH_SIZE_INFO_FAILURE
    };
    return axiosCall(config);
};

export let fetchSizeInfoMesData = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.sizeInfoMesGet}/${id}`,
        responseTypeRequest: FETCH_SIZE_INFO_MES_REQUEST,
        responseTypeSuccess: FETCH_SIZE_INFO_MES_SUCCESS,
        responseTypeFailure: FETCH_SIZE_INFO_MES_FAILURE
    };
    return axiosCall(config);
};

export let fetchSizeInfoMesSingleGet = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.sizeInfoMesSingleGet}/${id}`,
        responseTypeRequest: FETCH_SIZE_INFO_MES_SINGLE_GET_REQUEST,
        responseTypeSuccess: FETCH_SIZE_INFO_MES_SINGLE_GET_SUCCESS,
        responseTypeFailure: FETCH_SIZE_INFO_MES_SINGLE_GET_FAILURE
    };
    return axiosCall(config);
};


// CREATE SIZE INFO FORM
export let createSizeInfoForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_SIZE_INFO_FORM, payload: { key, value } });
    };
};

// CREATE SIZE INFO
export let createSizeInfo = (formData, modalClose) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: 0,
        fldIsActive: true,
        fldCreatedBy: 1,
        fldCreatedDt: today.toISOString(),
        fldModifiedBy: 0,
        fldModifiedDt: today.toISOString(),
        fldDeletedBy: 0,
        fldDeletedDt: today.toISOString(),
        ...formData,
        fldS01: formData?.fldS01?.toUpperCase(),
        fldS02: formData?.fldS02?.toUpperCase(),
        fldS03: formData?.fldS03?.toUpperCase(),
        fldS04: formData?.fldS04?.toUpperCase(),
        fldS05: formData?.fldS05?.toUpperCase(),
        fldS06: formData?.fldS06?.toUpperCase(),
        fldS07: formData?.fldS07?.toUpperCase(),
        fldS08: formData?.fldS08?.toUpperCase(),
        fldS09: formData?.fldS09?.toUpperCase(),
        fldS10: formData?.fldS10?.toUpperCase(),
        fldS11: formData?.fldS11?.toUpperCase(),
        fldS12: formData?.fldS12?.toUpperCase(),
        fldS13: formData?.fldS13?.toUpperCase(),
        fldS14: formData?.fldS14?.toUpperCase(),
        fldS15: formData?.fldS15?.toUpperCase(),
        fldS16: formData?.fldS16?.toUpperCase(),
        fldS17: formData?.fldS17?.toUpperCase(),
        fldS18: formData?.fldS18?.toUpperCase(),
        fldFKGender: parseInt(formData.fldFKGender),
        fldIsUpdated: true
    });
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.sizeInfoPOST}`,
        responseTypeRequest: CREATE_SIZE_INFO_REQUEST,
        responseTypeSuccess: CREATE_SIZE_INFO_SUCCESS,
        responseTypeFailure: CREATE_SIZE_INFO_FAILURE,
        resetFormData: RESET_SIZE_INFO_INFO,
        modalClose,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchSizeInfoData()
    };
    return axiosCall(config);
};

// GET SINGLE SIZE INFO
export let getSingleSizeInfo = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.sizeInfoGET_SINGLE_USER_ID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_SIZE_INFO_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_SIZE_INFO_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_SIZE_INFO_FAILURE,
        singlApiArray: [fetchGender()]
    };
    return axiosCall(config);
};



//UPDATE SIZE INFO
export let updateSizeInfo = (formData) => {
    let today = new Date();
    let data = {
        ...formData,
        fldS01: formData?.fldS01?.toUpperCase(),
        fldS02: formData?.fldS02?.toUpperCase(),
        fldS03: formData?.fldS03?.toUpperCase(),
        fldS04: formData?.fldS04?.toUpperCase(),
        fldS05: formData?.fldS05?.toUpperCase(),
        fldS06: formData?.fldS06?.toUpperCase(),
        fldS07: formData?.fldS07?.toUpperCase(),
        fldS08: formData?.fldS08?.toUpperCase(),
        fldS09: formData?.fldS09?.toUpperCase(),
        fldS10: formData?.fldS10?.toUpperCase(),
        fldS11: formData?.fldS11?.toUpperCase(),
        fldS12: formData?.fldS12?.toUpperCase(),
        fldS13: formData?.fldS13?.toUpperCase(),
        fldS14: formData?.fldS14?.toUpperCase(),
        fldS15: formData?.fldS15?.toUpperCase(),
        fldS16: formData?.fldS16?.toUpperCase(),
        fldS17: formData?.fldS17?.toUpperCase(),
        fldS18: formData?.fldS18?.toUpperCase(),
        fldModifiedBy: 1,
        fldModifiedDt: today.toISOString(),
        fldFKGender: parseInt(formData.fldFKGender)
    };
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.sizeInfoPATCH}/${formData.fldId}`,
        responseTypeRequest: UPDATE_SIZE_INFO_REQUEST,
        responseTypeSuccess: UPDATE_SIZE_INFO_SUCCESS,
        responseTypeFailure: UPDATE_SIZE_INFO_FAILURE,
        resetFormData: RESET_SIZE_INFO_INFO,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchSizeInfoData()
    };
    return axiosCall(config);
};


export let createSizeMes = (data, id) => {
    let today = new Date();
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.sizeInfoMesPost}`,
        responseTypeRequest: CREATE_SIZE_INFO_MES_REQUEST,
        responseTypeSuccess: CREATE_SIZE_INFO_MES_SUCCESS,
        responseTypeFailure: CREATE_SIZE_INFO_MES_FAILURE,
        // resetFormData: RESET_SIZE_INFO_INFO,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchSizeInfoMesData(id)
    };
    return axiosCall(config);
};

export let updateSizeMes = (data, id, getId) => {
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.sizeInfoMesUpdate}/${id}`,
        responseTypeRequest: UPDATE_SIZE_INFO_MES_REQUEST,
        responseTypeSuccess: UPDATE_SIZE_INFO_MES_SUCCESS,
        responseTypeFailure: UPDATE_SIZE_INFO_MES_FAILURE,
        // resetFormData: RESET_SIZE_INFO_INFO,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchSizeInfoMesData(getId)


    };
    return axiosCall(config);
};

// DELETE SIZE INFO
export let deleteSizeInfo = (id) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.sizeInfoDELETE}/${id}`,
        responseTypeRequest: DELETE_SIZE_INFO_REQUEST,
        responseTypeSuccess: DELETE_SIZE_INFO_SUCCESS,
        responseTypeFailure: DELETE_SIZE_INFO_FAILURE,
        modalClose: true,
        getAllData: fetchSizeInfoData()
    };
    return axiosCall(config);
};


export let deleteSizeMesInfo = (id, getId) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.sizeInfoMesDelete}/${id}`,
        responseTypeRequest: DELETE_SIZE_INFO_REQUEST,
        responseTypeSuccess: DELETE_SIZE_INFO_SUCCESS,
        responseTypeFailure: DELETE_SIZE_INFO_FAILURE,
        modalClose: true,
        getAllData: fetchSizeInfoMesData(getId)
    };
    return axiosCall(config);
};


// FETCH GENDER
export let fetchGender = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.PropertyList}/7`,
        responseTypeRequest: FETCH_GENDER_REQUEST,
        responseTypeSuccess: FETCH_GENDER_SUCCESS,
        responseTypeFailure: FETCH_GENDER_FAILURE
    };
    return axiosCall(config);
};



export let getSizeInfoInvoiceData = (id, style) => {
    let config = {
        method: 'get',
        //url: `${ConstantApi.sizeinfoInvoiceGET}?FldId=${id}`,
        url: `${ConstantApi.sizeinfoInvoiceGET}?FldId=${id}&mStyleNo=${style}`,
        // url: `${ConstantApi.sizeinfoInvoiceGET}?FldFKStyle=${style}&FldId=7`,
        responseTypeRequest: FETCH_SIZE_INFO_INVOICE_REQUEST,
        responseTypeSuccess: FETCH_SIZE_INFO_INVOICE_SUCCESS,
        responseTypeFailure: FETCH_SIZE_INFO_INVOICE_FAILURE
    };
    return axiosCall(config);
};